<div class="page-builder">
  <div class="row g-4">
    <!-- Configuration Panel -->
    <div :class="showPreview ? 'col-lg-5' : 'col-12'">
      <div class="card shadow-sm rounded-3 h-100">
        <div class="card-header bg-white border-0 pb-0">
          <h6 class="text-sm mb-0">
            <i class="bi bi-palette me-2 text-primary"></i>
            Page Builder
          </h6>
        </div>
        <div class="card-body pt-3">
          <!-- Tab Navigation -->
          <div class="builder-tabs">
            <button 
              class="builder-tab" 
              :class="{ active: active_tab === 'content' }"
              @click="set_tab('content')"
            >
              <i class="bi bi-type"></i>
              <span class="d-none d-md-inline">Content</span>
            </button>
            <button 
              class="builder-tab" 
              :class="{ active: active_tab === 'style' }"
              @click="set_tab('style')"
            >
              <i class="bi bi-palette2"></i>
              <span class="d-none d-md-inline">Style</span>
            </button>
            <button 
              class="builder-tab" 
              :class="{ active: active_tab === 'layout' }"
              @click="set_tab('layout')"
            >
              <i class="bi bi-grid-1x2"></i>
              <span class="d-none d-md-inline">Layout</span>
            </button>
            <button 
              class="builder-tab" 
              :class="{ active: active_tab === 'advanced' }"
              @click="set_tab('advanced')"
            >
              <i class="bi bi-gear"></i>
              <span class="d-none d-md-inline">Advanced</span>
            </button>
          </div>

          <!-- Tab Content -->
          <div class="config-scroll">
            <!-- CONTENT TAB -->
            <div v-show="active_tab === 'content'">
              <!-- Text Content -->
              <div class="config-section">
                <div class="section-title">Text Content</div>
                
                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Title</span>
                  </div>
                  <input 
                    type="text" 
                    class="form-control form-control-sm"
                    :value="config.title"
                    @input="update_field('title', $event.target.value)"
                    placeholder="Thank You!"
                  >
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Message</span>
                  </div>
                  <textarea 
                    class="form-control form-control-sm"
                    :value="config.message"
                    @input="update_field('message', $event.target.value)"
                    rows="2"
                    placeholder="Your success message here..."
                  ></textarea>
                  <div class="control-hint">Text will be displayed as plain text (no HTML formatting)</div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Additional Info</span>
                  </div>
                  <textarea 
                    class="form-control form-control-sm"
                    :value="config.additional_info"
                    @input="update_field('additional_info', $event.target.value)"
                    rows="2"
                    placeholder="Additional details..."
                  ></textarea>
                </div>
              </div>

              <!-- Buttons -->
              <div class="config-section">
                <div class="section-title">Buttons</div>
                
                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Primary Button Text</span>
                  </div>
                  <input 
                    type="text" 
                    class="form-control form-control-sm"
                    :value="config.button_text"
                    @input="update_field('button_text', $event.target.value)"
                    placeholder="Done"
                  >
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Back Button Text</span>
                  </div>
                  <input 
                    type="text" 
                    class="form-control form-control-sm"
                    :value="config.back_button_text"
                    @input="update_field('back_button_text', $event.target.value)"
                    placeholder="Go Back"
                  >
                </div>
              </div>

              <!-- Visibility Toggles -->
              <div class="config-section">
                <div class="section-title">Show / Hide Elements</div>
                
                <div class="toggle-row">
                  <span class="toggle-label">Show Icon</span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.show_icon"
                      @change="update_field('show_icon', $event.target.checked)"
                    >
                  </div>
                </div>

                <div class="toggle-row">
                  <span class="toggle-label">Show Logo</span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.show_logo"
                      @change="update_field('show_logo', $event.target.checked)"
                    >
                  </div>
                </div>

                <div class="toggle-row">
                  <span class="toggle-label">Show Title</span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.show_title"
                      @change="update_field('show_title', $event.target.checked)"
                    >
                  </div>
                </div>

                <div class="toggle-row">
                  <span class="toggle-label">Show Message</span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.show_message"
                      @change="update_field('show_message', $event.target.checked)"
                    >
                  </div>
                </div>

                <div class="toggle-row">
                  <span class="toggle-label">Show Additional Info</span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.show_additional_info"
                      @change="update_field('show_additional_info', $event.target.checked)"
                    >
                  </div>
                </div>

                <div class="toggle-row">
                  <span class="toggle-label">Show Primary Button</span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.show_dashboard_button"
                      @change="update_field('show_dashboard_button', $event.target.checked)"
                    >
                  </div>
                </div>

                <div class="toggle-row">
                  <span class="toggle-label">Show Back Button</span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.show_back_button"
                      @change="update_field('show_back_button', $event.target.checked)"
                    >
                  </div>
                </div>

                <div class="toggle-row">
                  <span class="toggle-label">
                    Show Confetti 
                    <i class="bi bi-stars text-warning ms-1"></i>
                  </span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.show_confetti"
                      @change="update_field('show_confetti', $event.target.checked)"
                    >
                  </div>
                </div>
              </div>

              <!-- Logo Settings -->
              <div class="config-section" v-if="config.show_logo">
                <div class="section-title">Logo Settings</div>
                
                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Logo URL</span>
                  </div>
                  <input 
                    type="text" 
                    class="form-control form-control-sm"
                    :value="config.logo_url"
                    @input="update_field('logo_url', $event.target.value)"
                    placeholder="https://example.com/logo.png"
                  >
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Logo Size</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.logo_size === 'small' }"
                      @click="update_field('logo_size', 'small')"
                    >Small</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.logo_size === 'medium' }"
                      @click="update_field('logo_size', 'medium')"
                    >Medium</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.logo_size === 'large' }"
                      @click="update_field('logo_size', 'large')"
                    >Large</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- STYLE TAB -->
            <div v-show="active_tab === 'style'">
              <!-- Icon Selection -->
              <div class="config-section" v-if="config.show_icon">
                <div class="section-title">Icon</div>
                
                <div class="icon-grid mb-3">
                  <button 
                    v-for="icon in icon_options" 
                    :key="icon.value"
                    class="icon-option"
                    :class="{ active: config.icon_type === icon.value }"
                    @click="select_icon(icon.value)"
                    :title="icon.label"
                  >
                    <i :class="icon.icon"></i>
                  </button>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Icon Style</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.icon_style === 'filled' }"
                      @click="update_field('icon_style', 'filled')"
                    >Filled</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.icon_style === 'outline' }"
                      @click="update_field('icon_style', 'outline')"
                    >Outline</button>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Icon Size</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.icon_size === 'small' }"
                      @click="update_field('icon_size', 'small')"
                    >S</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.icon_size === 'medium' }"
                      @click="update_field('icon_size', 'medium')"
                    >M</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.icon_size === 'large' }"
                      @click="update_field('icon_size', 'large')"
                    >L</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.icon_size === 'xl' }"
                      @click="update_field('icon_size', 'xl')"
                    >XL</button>
                  </div>
                </div>
              </div>

              <!-- Colors -->
              <div class="config-section">
                <div class="section-title">Colors</div>
                
                <div class="color-row mb-3">
                  <div class="color-item">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.background_color"
                      @input="update_field('background_color', $event.target.value)"
                    >
                    <span class="color-label">Background</span>
                  </div>
                  <div class="color-item">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.card_background"
                      @input="update_field('card_background', $event.target.value)"
                    >
                    <span class="color-label">Card</span>
                  </div>
                  <div class="color-item" v-if="config.show_icon">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.icon_color"
                      @input="update_field('icon_color', $event.target.value)"
                    >
                    <span class="color-label">Icon</span>
                  </div>
                  <div class="color-item">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.title_color"
                      @input="update_field('title_color', $event.target.value)"
                    >
                    <span class="color-label">Title</span>
                  </div>
                  <div class="color-item">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.message_color"
                      @input="update_field('message_color', $event.target.value)"
                    >
                    <span class="color-label">Message</span>
                  </div>
                </div>

                <!-- Gradient Toggle -->
                <div class="toggle-row">
                  <span class="toggle-label">Use Gradient Background</span>
                  <div class="form-check form-switch mb-0">
                    <input 
                      class="form-check-input" 
                      type="checkbox"
                      :checked="config.background_gradient"
                      @change="update_field('background_gradient', $event.target.checked)"
                    >
                  </div>
                </div>

                <div v-if="config.background_gradient" class="gradient-controls">
                  <div class="color-row">
                    <div class="color-item">
                      <input 
                        type="color" 
                        class="color-picker"
                        :value="config.background_gradient_from"
                        @input="update_field('background_gradient_from', $event.target.value)"
                      >
                      <span class="color-label">From</span>
                    </div>
                    <div class="color-item">
                      <input 
                        type="color" 
                        class="color-picker"
                        :value="config.background_gradient_to"
                        @input="update_field('background_gradient_to', $event.target.value)"
                      >
                      <span class="color-label">To</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Button Styling -->
              <div class="config-section">
                <div class="section-title">Primary Button</div>
                
                <div class="color-row mb-3">
                  <div class="color-item">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.primary_button_color"
                      @input="update_field('primary_button_color', $event.target.value)"
                    >
                    <span class="color-label">Color</span>
                  </div>
                  <div class="color-item">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.primary_button_text_color"
                      @input="update_field('primary_button_text_color', $event.target.value)"
                    >
                    <span class="color-label">Text</span>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Button Style</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.primary_button_style === 'filled' }"
                      @click="update_field('primary_button_style', 'filled')"
                    >Filled</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.primary_button_style === 'outline' }"
                      @click="update_field('primary_button_style', 'outline')"
                    >Outline</button>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Button Shape</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.primary_button_radius === 'square' }"
                      @click="update_field('primary_button_radius', 'square')"
                    >Square</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.primary_button_radius === 'rounded' }"
                      @click="update_field('primary_button_radius', 'rounded')"
                    >Rounded</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.primary_button_radius === 'pill' }"
                      @click="update_field('primary_button_radius', 'pill')"
                    >Pill</button>
                  </div>
                </div>
              </div>

              <!-- Secondary Button -->
              <div class="config-section" v-if="config.show_back_button">
                <div class="section-title">Secondary Button</div>
                
                <div class="color-row mb-3">
                  <div class="color-item">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.secondary_button_color"
                      @input="update_field('secondary_button_color', $event.target.value)"
                    >
                    <span class="color-label">Color</span>
                  </div>
                  <div class="color-item">
                    <input 
                      type="color" 
                      class="color-picker"
                      :value="config.secondary_button_text_color"
                      @input="update_field('secondary_button_text_color', $event.target.value)"
                    >
                    <span class="color-label">Text</span>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Button Style</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.secondary_button_style === 'filled' }"
                      @click="update_field('secondary_button_style', 'filled')"
                    >Filled</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.secondary_button_style === 'outline' }"
                      @click="update_field('secondary_button_style', 'outline')"
                    >Outline</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- LAYOUT TAB -->
            <div v-show="active_tab === 'layout'">
              <!-- Typography -->
              <div class="config-section">
                <div class="section-title">Typography</div>
                
                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Font Family</span>
                  </div>
                  <select 
                    class="form-select form-select-sm"
                    :value="config.font_family"
                    @change="update_field('font_family', $event.target.value)"
                  >
                    <option v-for="font in font_options" :key="font.value" :value="font.value">
                      {{ font.label }}
                    </option>
                  </select>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Title Size</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.title_size === 'small' }"
                      @click="update_field('title_size', 'small')"
                    >S</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.title_size === 'medium' }"
                      @click="update_field('title_size', 'medium')"
                    >M</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.title_size === 'large' }"
                      @click="update_field('title_size', 'large')"
                    >L</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.title_size === 'xl' }"
                      @click="update_field('title_size', 'xl')"
                    >XL</button>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Title Weight</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.title_weight === 'normal' }"
                      @click="update_field('title_weight', 'normal')"
                    >Normal</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.title_weight === 'semibold' }"
                      @click="update_field('title_weight', 'semibold')"
                    >Semi</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.title_weight === 'bold' }"
                      @click="update_field('title_weight', 'bold')"
                    >Bold</button>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Message Size</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.message_size === 'small' }"
                      @click="update_field('message_size', 'small')"
                    >S</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.message_size === 'medium' }"
                      @click="update_field('message_size', 'medium')"
                    >M</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.message_size === 'large' }"
                      @click="update_field('message_size', 'large')"
                    >L</button>
                  </div>
                </div>
              </div>

              <!-- Card Layout -->
              <div class="config-section">
                <div class="section-title">Card Layout</div>
                
                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Content Width</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.content_width === 'small' }"
                      @click="update_field('content_width', 'small')"
                    >Narrow</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.content_width === 'medium' }"
                      @click="update_field('content_width', 'medium')"
                    >Medium</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.content_width === 'large' }"
                      @click="update_field('content_width', 'large')"
                    >Wide</button>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Card Padding</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.padding === 'compact' }"
                      @click="update_field('padding', 'compact')"
                    >Compact</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.padding === 'comfortable' }"
                      @click="update_field('padding', 'comfortable')"
                    >Comfortable</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.padding === 'spacious' }"
                      @click="update_field('padding', 'spacious')"
                    >Spacious</button>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Card Corners</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_radius === 'none' }"
                      @click="update_field('card_radius', 'none')"
                    >Sharp</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_radius === 'small' }"
                      @click="update_field('card_radius', 'small')"
                    >S</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_radius === 'medium' }"
                      @click="update_field('card_radius', 'medium')"
                    >M</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_radius === 'large' }"
                      @click="update_field('card_radius', 'large')"
                    >L</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_radius === 'xl' }"
                      @click="update_field('card_radius', 'xl')"
                    >XL</button>
                  </div>
                </div>

                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Card Shadow</span>
                  </div>
                  <div class="segment-buttons">
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_shadow === 'none' }"
                      @click="update_field('card_shadow', 'none')"
                    >None</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_shadow === 'small' }"
                      @click="update_field('card_shadow', 'small')"
                    >Subtle</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_shadow === 'medium' }"
                      @click="update_field('card_shadow', 'medium')"
                    >Medium</button>
                    <button 
                      class="segment-btn" 
                      :class="{ active: config.card_shadow === 'large' }"
                      @click="update_field('card_shadow', 'large')"
                    >Strong</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- ADVANCED TAB -->
            <div v-show="active_tab === 'advanced'">
              <!-- Animation -->
              <div class="config-section">
                <div class="section-title">Animation</div>
                
                <div class="control-group">
                  <div class="control-label">
                    <span class="control-label-text">Page Animation</span>
                  </div>
                  <div class="d-flex gap-2 align-items-center">
                    <select 
                      class="form-select form-select-sm flex-grow-1"
                      :value="config.animation"
                      @change="update_field('animation', $event.target.value)"
                    >
                      <option v-for="anim in animation_options" :key="anim.value" :value="anim.value">
                        {{ anim.label }}
                      </option>
                    </select>
                    <button 
                      class="btn btn-outline-primary btn-sm" 
                      @click="replay_animation"
                      title="Replay animation"
                    >
                      <i class="bi bi-play-fill"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Custom CSS -->
              <div class="config-section">
                <div class="section-title">Custom CSS</div>
                
                <div class="control-group">
                  <textarea 
                    class="css-editor w-100"
                    :value="config.custom_css"
                    @input="update_field('custom_css', $event.target.value)"
                    placeholder="/* Add custom CSS here */
.preview-card {
  /* Your styles */
}"
                  ></textarea>
                  <div class="control-hint">Advanced: Add custom CSS to override default styles</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Live Preview -->
    <div v-if="showPreview" class="col-lg-7">
      <div class="card shadow-sm rounded-3 h-100">
        <div class="card-header bg-white border-0 pb-0 d-flex justify-content-between align-items-center">
          <h6 class="text-sm mb-0">
            <i class="bi bi-eye me-2 text-success"></i>
            Live Preview
          </h6>
          <button 
            class="btn btn-outline-primary btn-sm text-xs"
            @click="replay_animation"
          >
            <i class="bi bi-arrow-clockwise me-1"></i>
            Replay
          </button>
        </div>
        <div class="card-body">
          <div class="device-frame">
            <div class="device-screen">
              <div 
                class="preview-container" 
                :style="preview_styles"
                :key="animation_key"
              >
                <!-- Confetti indicator -->
                <div v-if="config.show_confetti" class="confetti-indicator">
                  <i class="bi bi-stars text-warning"></i>
                  Confetti enabled
                </div>

                <!-- Preview Card -->
                <div 
                  class="preview-card"
                  :class="animation_class"
                  :style="card_styles"
                >
                  <!-- Logo -->
                  <div v-if="config.show_logo && config.logo_url" class="mb-3">
                    <img 
                      :src="config.logo_url" 
                      alt="Logo" 
                      :style="logo_styles"
                      style="max-width: 200px;"
                    >
                  </div>

                  <!-- Icon -->
                  <div v-if="config.show_icon" class="preview-icon">
                    <i :class="icon_class" :style="icon_styles"></i>
                  </div>

                  <!-- Title -->
                  <h3 v-if="config.show_title" class="preview-title" :style="title_styles">
                    {{ config.title || 'Thank You!' }}
                  </h3>

                  <!-- Message -->
                  <p 
                    v-if="config.show_message" 
                    class="preview-message" 
                    :style="message_styles"
                  >
                    {{ config.message || 'Your message here...' }}
                  </p>

                  <!-- Additional Info -->
                  <div 
                    v-if="config.show_additional_info && config.additional_info" 
                    class="preview-additional"
                    :style="additional_info_styles"
                  >
                    {{ config.additional_info }}
                  </div>

                  <!-- Buttons -->
                  <div class="preview-buttons">
                    <button 
                      v-if="config.show_dashboard_button"
                      class="preview-btn"
                      :style="primary_button_styles"
                    >
                      {{ config.button_text || 'Done' }}
                    </button>
                    <button 
                      v-if="config.show_back_button"
                      class="preview-btn"
                      :style="secondary_button_styles"
                    >
                      {{ config.back_button_text || 'Go Back' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
